import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';

import { parseQs, toQueryString } from 'helpers/http';

import List from 'components/List';

import Breadcrumb from 'components/layout/Breadcrumb';
import Loader from 'components/layout/Loader';
import ListFilterCompany from 'components/layout/list/filters/ListFilterCompany';
import ListFilterDateBetween from 'components/layout/list/filters/ListFilterDateBetween';
// import ListFilterInvoicePaymentStatus from 'components/layout/list/filters/ListFilterInvoicePaymentStatus'; Todo in Backend
import ListFilterInvoicePaymentMethod from 'components/layout/list/filters/ListFilterInvoicePaymentMethod';

import ListFilterReset from 'components/layout/list/ListFilterReset';

import InvoicesList from 'components/layout/financial/InvoicesList';

import DocMeta from 'components/DocMeta';
import { generateMetaTags } from 'helpers/metaTags';

import may from 'js/security';
import { ROLE_ROOT_EMPLOYEE } from 'js/constants';
import { Button } from 'react-bootstrap';
import Axios from 'axios';
import { confirmAlert } from 'react-confirm-alert';
import moment from 'moment';
import fileDownload from 'js-file-download';
// import { add } from 'lodash';

class Invoices extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isDownloading: false,
    };
  }

  handleRowClick = invoice => {
    const { appIntl, history } = this.props;
    history.push(appIntl.urlPrefix + 'account/settings/invoices/' + invoice.id);
  };

  getInvoices = () => {
    const {
      list,
      intl: { messages },
      location,
    } = this.props;

    const params = new URLSearchParams(location.search);

    params.set('csv', 'invoices');

    const {
      data: { count },
      activePage,
      resPerPage,
      searchTerm,
      sort,
      dir,
    } = list;

    const offset = count > 0 ? (activePage - 1) * resPerPage : 0;

    params.set('offset', offset);
    params.set('limit', resPerPage);
    params.set('search', searchTerm);
    params.set('sort', sort);
    params.set('dir', dir);
    params.set('page', activePage);
    params.set('locale', 'de');

    const urlData = this.getUrlData(parseQs(location.search));
    const additionalQuery = toQueryString(urlData);
    const urlString = `/api/invoices.json?${params.toString()}&${additionalQuery}`;

    this.setState({ isDownloading: true });

    Axios({
      url: urlString,
      method: 'GET',
      responseType: 'blob',
    })
      .then(({ data, headers }) => {
        const filename = headers?.['content-disposition']?.split?.('filename=')?.[1] ?? 'invoices.csv';
        fileDownload(data, filename);

        this.setState({ isDownloading: false }, () => {
          const options = {
            customUI: ({ onClose }) => {
              return (
                <div className="react-confirm-alert-body">
                  <h1>{messages.salesDoc.download_csv_ready}</h1>
                  <div className="react-confirm-alert-button-group" style={{ width: '100%', margin: '0 auto' }}>
                    <Button
                      style={{ margin: '0 auto', marginTop: '20px', width: '100px' }}
                      bsStyle="primary"
                      onClick={onClose}
                    >
                      OK
                    </Button>
                  </div>
                </div>
              );
            },
            childrenElement: () => <div />,
            closeOnEscape: true,
            closeOnClickOutside: true,
          };
          confirmAlert(options);
        });
      })
      .catch(error => {
        // handle error
        if (Axios.isCancel(error)) {
          console.log('post Request canceled');
        } else {
          console.error(error);
        }
      });
  };

  getBreadcrumb = () => {
    const {
      intl: { messages },
      appIntl: { urlPrefix },
    } = this.props;

    return (
      <Breadcrumb
        crumbs={[
          { link: `${urlPrefix}account/settings`, name: messages.settings },
          { link: `${urlPrefix}account`, name: 'Dashboard' },
          { link: null, name: messages.salesDoc.invoices },
        ]}
        className="p-t-0"
      />
    );
  };

  /**
   * Construct an object with 'filters': { target, paymentMethod }
   * and optional 'dateFrom' and 'dateTo' UTC datetimes.
   * @param {Object} query query string parsed into an Object by 'qs' module, with optional nesting
   * @returns {Object} Object with 'filters' and optional 'dateFrom' and 'dateTo' UTC datetime strings
   */
  getUrlData = ({ target, paymentMethod, dateFrom, dateTo }) => {
    const urlData = {
      filters: { target, paymentMethod },
    };
    if (dateFrom) {
      urlData.dateFrom = moment.tz(dateFrom, 'UTC').format('YYYY-MM-DD 00:00:00');
    }
    if (dateTo) {
      urlData.dateTo = moment.tz(dateTo, 'UTC').format('YYYY-MM-DD 23:59:59');
    }

    return urlData;
  };

  render() {
    const {
      intl: { messages },
      list,
      user,
      location,
    } = this.props;

    const { isDownloading } = this.state;
    const query = parseQs(location.search);
    const urlData = this.getUrlData(query);

    const filters = [];
    if (may(ROLE_ROOT_EMPLOYEE, user.roles)) {
      filters.push(<ListFilterCompany key="target" />);
      // filters.push(<ListFilterInvoicePaymentStatus key="paymentStatus" />);
      filters.push(<ListFilterInvoicePaymentMethod key="paymentMethod" />);
      filters.push(
        <ListFilterDateBetween
          label={messages.date}
          dateFrom={query.dateFrom}
          dateTo={query.dateTo}
          fromMaxDate={moment()}
          toMaxDate={moment()}
          key="date-between"
        />
      );
      filters.push(<ListFilterReset key="reset-all" availableFilters={['target', 'paymentMethod', 'is-active']} />);
    }
    // filters.push(<ListFilterInvoiceDirection key="doc-direction-filter" />);
    return (
      <DocMeta tags={generateMetaTags(messages.meta.bills)}>
        <List
          listName="invoices"
          url="/api/invoiceslist.json"
          urlData={urlData}
          list={list}
          title={messages.salesDoc.invoices}
          iconClass="fal fa-file-alt"
          showNew={false}
          newAction={null}
          showSearch={false}
          showSearchNumber
          sortOptions={['cdate,desc', 'countryName,asc', 'vat,asc', 'sumGross,asc']}
          breadcrumb={this.getBreadcrumb()}
          filters={filters}
          changeActivePage={this.changeActivePage}
        >

          {may(ROLE_ROOT_EMPLOYEE, user.roles) ? (
            <Button bsStyle="default" onClick={() => this.getInvoices()} disabled={isDownloading}>
              <p style={{ margin: '0' }}>
                {isDownloading && <i className="far fa-spin fa-spinner-third" />}
                <span> {messages.download_invoices}</span>
              </p>
            </Button>
          ) : (
            <></>
          )}

          {list.pending ? (
            <Loader />
          ) : (
            <InvoicesList list={list.data.list} showDetailsAction={this.handleRowClick} listName="invoices" />
          )}
        </List>
      </DocMeta>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    list: state.list.invoices,
    user: state.login.user,
  };
};

export default withRouter(injectIntl(connect(mapStateToProps)(Invoices)));
